import { render, staticRenderFns } from "./SearchResultFooter.vue?vue&type=template&id=9ce57088&"
import script from "./SearchResultFooter.vue?vue&type=script&lang=ts&"
export * from "./SearchResultFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports